<template>
  <MRow>
    <MCol :size="6">
      <FlotoFormItem
        id="start-at-picker"
        rules="required|nonzero"
        :label="$t('start_at', { type: '' })"
      >
        <FlotoDatePicker
          v-if="!disabled"
          v-model="schedule.startAt"
          :min-date="Moment().valueOf()"
        />
        <template v-else>
          <span v-if="schedule.startAt">
            {{ schedule.startAt | datetime }}
          </span>
          <span v-else>---</span>
        </template>
      </FlotoFormItem>
    </MCol>
    <MCol :size="6">
      <FlotoFormItem
        id="recurring-date-picker"
        rules="required"
        :label="$tc('date')"
      >
        <FlotoDropdownPicker
          v-if="!disabled"
          v-model="schedule.recurringDate"
          as-input
          :options="dateOptions"
        />
        <template v-else>
          {{
            schedule.recurringDate
              ? (
                  dateOptions.find((o) => o.key === schedule.recurringDate) ||
                  {}
                ).text
              : '---'
          }}
        </template>
      </FlotoFormItem>
    </MCol>
    <MCol :size="6">
      <FlotoFormItem
        id="recurring-hour-input"
        rules="required"
        :label="$t('time', { type: '' })"
      >
        <HourInput v-model="schedule.recurringHour" :disabled="disabled" />
      </FlotoFormItem>
    </MCol>
    <MCol :size="6">
      <FlotoFormItem
        id="recurrong-month-input"
        rules="required"
        :label="$tc('months')"
      >
        <MonthInput v-model="schedule.recurringMonth" :disabled="disabled" />
      </FlotoFormItem>
    </MCol>
  </MRow>
</template>

<script>
import Moment from 'moment'
import Range from 'lodash/range'
import HourInput from './hour-input'
import MonthInput from './month-input'

export default {
  name: 'MonthlyInput',
  components: { HourInput, MonthInput },
  model: { event: 'change' },
  props: {
    value: { type: Object, required: true },
    disabled: { type: Boolean, required: false },
  },
  data() {
    this.Moment = Moment
    return {}
  },
  computed: {
    dateOptions() {
      return Range(1, 32).map((d) => ({ text: d, key: d }))
    },
    monthOptions() {
      return Range(1, 13).map((d) => ({ text: d, key: d }))
    },
    schedule: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', v)
      },
    },
  },
}
</script>
